import React, { useState } from 'react';
import { useReactFlow } from '@xyflow/react';
import { useApi } from '../../../../context/ApiContext/ApiContext';
import { Play, ChevronLeft, ChevronRight, X, RefreshCw } from 'lucide-react';
import { moduleConfig } from './SmartplayExamplesModuleConfig';

const SmartplayVideosList = ({ id, data }) => {
  const { getNode } = useReactFlow();
  const { updateSharedParams } = useApi();
  const node = getNode(id);
  const [currentPage, setCurrentPage] = useState(0);
  
  
  const categories = Object.entries(moduleConfig?.moduleConfig?.categories);
  const currentCategory = categories[currentPage]?.[1] || {};

  // Geoblocking
  const [isoCountryCodes, setIsoCountryCodes] = useState("");
  // Utility function checks if current category is geoblocking
  const isGeoBlockingCategory = () => {
    const categoryName = categories[currentPage]?.[0] || '';
    return categoryName.toLowerCase() === "geoblocking";
  };

  const handlePlay = async (videoKey) => {
    // Always start with a fresh copy from the source config
    const players = JSON.parse(JSON.stringify(currentCategory[videoKey].players));
    
    if (!players) return;
    
    // Process the fresh copy with current ISO codes
    if (isGeoBlockingCategory()) {
      Object.keys(players).forEach(playerKey => {
        const player = players[playerKey];
        if (player && player.url && player.url.includes("{ISO}")) {
          player.url = player.url.replace("{ISO}", isoCountryCodes);
        }
      });
    }
  
    // Clear first
    await new Promise(resolve => {
      updateSharedParams({ players: null });
      resolve();
    });
  
    // Then update with processed players
    await new Promise(resolve => {
      updateSharedParams({ players });
      resolve();
    });
  };
  // const handlePlay = async (players) => {
  //   console.log("players", players);
  //   if (!players) return;
    
  //   // Process players object to replace {ISO} in URLs if needed
  //   const processedPlayers = { ...players };
    
  //   if (isGeoBlockingCategory()) {
  //     // Process each player URL for ISO replacement
  //     Object.keys(processedPlayers).forEach(playerKey => {
  //       const player = processedPlayers[playerKey];
  //       if (player && player.url && player.url.includes("{ISO}")) {
  //         player.url = player.url.replace("{ISO}", isoCountryCodes);
  //       }
  //     });
  //   }
  
  //   // Wait for first update to complete (clear players)
  //   await new Promise(resolve => {
  //     updateSharedParams({
  //       players: null
  //     });
  //     resolve();
  //   });
  
  //   // Log information
  //   console.log("categories: ", categories);
  //   console.log("Clicked Play Players: ", processedPlayers);
  
  //   // Wait for second update to complete
  //   await new Promise(resolve => {
  //     updateSharedParams({
  //       players: processedPlayers
  //     });
  //     resolve();
  //   });
  // };
    

  return (
    <div 
      className="relative bg-[#000000bb] text-white flex flex-col justify-center nowheel nopan overflow-hidden"
      style={{
        borderWidth: data.style.borderWidth,
        borderColor: data.style.borderColor,
        borderRadius: "20px",
        width: node.width,
        height: node.height,
        minWidth: '320px',
        minHeight: '240px',
      }}
    >
      <header className="py-1.5 text-[1.2em] font-bold text-gray-400 text-center">
        SmartPlay Demo
      </header>

      {/* <button className="absolute top-0 right-0 h-6 w-14 border-b border-l rounded-bl rounded-tr-2xl border-gray-600 bg-gray-900 hover:font-bold"
        title="Clear Player URL"
        onClick={() => {
          updateSharedParams(
            {
              "players": null
            }
          )
        }}
      >
        Clear

      </button> */}
      <button 
        className="absolute top-2 right-2 flex items-center gap-1 px-2 py-1 rounded bg-gray-700 hover:bg-gray-600 text-xs transition-colors"
        title="Reset all players"
        onClick={() => updateSharedParams({ players: null })}
      >
        <RefreshCw size={14} />
      </button>
      
      <div className="flex flex-col flex-grow px-2 overflow-hidden">

        {/* Videos Grid */}
        <div className="grid grid-cols-1 gap-1.5 overflow-y-auto">
          {Object.entries(currentCategory).map(([key, video]) => (
            <div 
              key={key}
              className="bg-gray-800 border border-gray-600 rounded-lg p-1.5 transition-colors"
            >
              <div className="flex flex-row items-center gap-2">
                {/* Only need to check player1 for URL */}
                {video.players && video.players.player1?.url && (
                  // <button 
                  //   onClick={() => handlePlay(video.players)}
                  //   className="bg-blue-500 p-1.5 ml-2 mr-1 rounded-full flex-shrink-0 hover:bg-blue-400"
                  //   title={video.players.player1?.url || ""}
                  // >
                  //   <Play size={20} className="fill-current" />
                  // </button>
                  <button 
                    onClick={() => handlePlay(key)} // Pass the key not the players
                    className="bg-blue-500 p-1.5 ml-2 mr-1 rounded-full flex-shrink-0 hover:bg-blue-400"
                    title={video.players.player1?.url || ""}
                  >
                    <Play size={20} className="fill-current" />
                  </button>

                )}
                <div className="w-full pr-8">
                  <h4 className="font-medium text-sm text-center">{video.title}</h4>
                  {video.description && (
                    <p className="text-xs text-center text-gray-300 mt-0">{video.description}</p>
                  )}
                </div>
              </div>

              {/* Geoblocking UI */}
              {isGeoBlockingCategory() && (
                <div className="mt-0 mb-0 pt-2 pb-2">
                  <div className="flex">
                    <input
                      type="text"
                      value={isoCountryCodes}
                      onChange={(e) => setIsoCountryCodes(e.target.value)}
                      placeholder="us,gb,de"
                      className="flex-grow bg-gray-900 text-white text-center px-2 py-1 rounded-l-md border border-gray-600 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    />
                    <button
                      onClick={() => setIsoCountryCodes("")}
                      className="bg-gray-600 hover:bg-gray-500 px-2 rounded-r-md"
                      title="Clear country codes"
                    >
                      ×
                    </button>
                  </div>
                  <div className="text-xs text-gray-400 mt-1">
                    Example: us,gb,de (United States, Great Britain, Germany)
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

      </div>

      {/* Pagination */}
      <div className="relative flex justify-between items-center border-t border-gray-700">
        
        {/* Page Left */}
        <button 
          onClick={() => setCurrentPage(prev => (prev - 1 + categories.length) % categories.length)}
          disabled={categories.length <= 1}
          className="pl-2 py-1 disabled:opacity-30"
        >
          <ChevronLeft size={20} />
        </button>
        
        {/* Page Left Category */}
        <div className="absolute left-5 pl-3 text-right text-xs font-bold text-gray-400"
            onClick={() => setCurrentPage(prev => (prev - 1 + categories.length) % categories.length)}
        >
          {/* Category Title */}
          {categories[currentPage - 1]?.[0] || ''}
        </div>

        {/* CURRENT CATEGORY */}
        <div className="text-[1.1em] font-bold text-gray-200">
          {/* Category Title */}
          {categories[currentPage]?.[0] || ''}
        </div>
        
        {/* Page Right Category */}
        <div className="absolute right-5 pr-3 text-right text-xs font-bold text-gray-400"
          onClick={() => setCurrentPage(prev => (prev + 1) % categories.length)}
        >
          {/* Category Title */}
          {categories[currentPage + 1]?.[0] || ''}
        </div>
        
        {/* Page Right */}
        <button 
          onClick={() => setCurrentPage(prev => (prev + 1) % categories.length)}
          disabled={categories.length <= 1}
          className="pr-2 py-1 disabled:opacity-30"
        >
          <ChevronRight size={20} />
        </button>

      </div>
    </div>
  );
};

export default SmartplayVideosList;



// import React, { useState } from 'react';
// import { useReactFlow } from '@xyflow/react';
// import { useApi } from '../../../../context/ApiContext/ApiContext';
// import { Play, ChevronLeft, ChevronRight } from 'lucide-react';
// import { moduleConfig } from './SmartplayExamplesModuleConfig';

// const SmartplayVideosList = ({ id, data }) => {
//   const { getNode } = useReactFlow();
//   const { updateSharedParams } = useApi();
//   const node = getNode(id);
//   const [currentPage, setCurrentPage] = useState(0);
  
  
//   const categories = Object.entries(moduleConfig?.moduleConfig?.categories);
//   const currentCategory = categories[currentPage]?.[1] || {};

//   // Geoblocking
//   const [isoCountryCodes, setIsoCountryCodes] = useState("");
//   // Utility function checks if current category is geoblocking
//   const isGeoBlockingCategory = () => {
//     const categoryName = categories[currentPage]?.[0] || '';
//     return categoryName.toLowerCase() === "geoblocking";
//   };

//   const handlePlay = async (url, url2 = null, url3 = null, url4 = null) => {
//     // Process URLs to replace {ISO} if needed
//     const processUrl = (urlToProcess) => {
//       if (urlToProcess && isGeoBlockingCategory() && urlToProcess.includes("{ISO}")) {
//         return urlToProcess.replace("{ISO}", isoCountryCodes);
//       }
//       return urlToProcess;
//     };
  
//     const processedUrl = processUrl(url);
//     const processedUrl2 = processUrl(url2);
//     const processedUrl3 = processUrl(url3);
//     const processedUrl4 = processUrl(url4);
  
//     // Wait for first update to complete
//     await new Promise(resolve => {
//       updateSharedParams({
//         playerURL: null,
//         playerURL2: null,
//         playerURL3: null,
//         playerURL4: null,
//       });
//       resolve();
//     });
  
//     // Log information
//     console.log("categories: ", categories);
//     console.log("Clicked Play URL1: ", processedUrl);
//     console.log("Clicked Play URL2: ", processedUrl2);
//     console.log("Clicked Play URL3: ", processedUrl3);
//     console.log("Clicked Play URL4: ", processedUrl4);
  
//     // Wait for second update to complete
//     await new Promise(resolve => {
//       updateSharedParams({
//         playerURL: processedUrl,
//         playerURL2: processedUrl2,
//         playerURL3: processedUrl3,
//         playerURL4: processedUrl4,
//       });
//       resolve();
//     });
//   };
    

//   return (
//     <div 
//       className="relative bg-[#000000bb] text-white flex flex-col justify-center nowheel nopan overflow-hidden"
//       style={{
//         borderWidth: data.style.borderWidth,
//         borderColor: data.style.borderColor,
//         borderRadius: "20px",
//         width: node.width,
//         height: node.height,
//         minWidth: '320px',
//         minHeight: '240px',
//       }}
//     >
//       <header className="py-1.5 text-[1.2em] font-bold text-gray-400 text-center">
//         Smartplay Demo
//       </header>
//       <button className="absolute top-0 right-0 h-6 w-14 border-b border-l rounded-bl rounded-tr-2xl border-gray-600 bg-gray-900 hover:font-bold"
//         title="Clear Player URL"
//         onClick={() => {
//           updateSharedParams(
//             {
//               "playerURL": null,
//               "playerURL2": null,
//               "playerURL3": null,
//               "playerURL4": null 
//             }
//           )
//         }}
//       >
//         Clear

//       </button>
      
//       <div className="flex flex-col flex-grow px-2 overflow-hidden">

//         {/* Videos Grid */}
//         <div className="grid grid-cols-1 gap-1.5 overflow-y-auto">
//           {Object.entries(currentCategory).map(([key, video]) => (
//             <div 
//               key={key}
//               className="bg-gray-800 border border-gray-600 rounded-lg p-1.5 transition-colors"
//               // style={{ minHeight: '40px' }}
//             >
//               <div className="flex flex-row items-center gap-2">
//                 {video.playerURL && (
//                   <button 
//                     onClick={() => handlePlay(video.playerURL, video.playerURL2 || null, video.playerURL3 || null, video.playerURL4 || null )}
//                     className="bg-blue-500 p-1.5 ml-2 mr-1 rounded-full flex-shrink-0 hover:bg-blue-400"
//                     title={video.playerURL}
//                   >
//                     <Play size={20} className="fill-current" />
//                   </button>
//                 )}
//                 <div className="w-full pr-8">
//                   <h4 className="font-medium text-sm text-center">{video.title}</h4>
//                   {video.description && (
//                     <p className="text-xs text-center text-gray-300 mt-0">{video.description}</p>
//                   )}
//                 </div>
//               </div>

//               {/* Geoblocking UI */}
//               {isGeoBlockingCategory() && (
//                 <div className="mt-0 mb-0 pt-2 pb-2">
//                   {/* <label className="block text-sm font-medium text-gray-300 mb-1">
//                     ISO Country Codes
//                   </label> */}
//                   <div className="flex">
//                     <input
//                       type="text"
//                       value={isoCountryCodes}
//                       onChange={(e) => setIsoCountryCodes(e.target.value)}
//                       placeholder="us,gb,de"
//                       className="flex-grow bg-gray-900 text-white text-center px-2 py-1 rounded-l-md border border-gray-600 focus:outline-none focus:ring-1 focus:ring-blue-500"
//                     />
//                     <button
//                       onClick={() => setIsoCountryCodes("")}
//                       className="bg-gray-600 hover:bg-gray-500 px-2 rounded-r-md"
//                       title="Clear country codes"
//                     >
//                       ×
//                     </button>
//                   </div>
//                   <div className="text-xs text-gray-400 mt-1">
//                     Example: us,gb,de (United States, Great Britain, Germany)
//                   </div>
//                 </div>
//               )}
//             </div>
//           ))}
        


//         </div>

//       </div>

//       {/* Pagination */}
//       <div className="relative flex justify-between items-center border-t border-gray-700">
        
//         {/* Page Left */}
//         <button 
//           onClick={() => setCurrentPage(prev => (prev - 1 + categories.length) % categories.length)}
//           disabled={categories.length <= 1}
//           className="pl-2 py-1 disabled:opacity-30"
//         >
//           <ChevronLeft size={20} />
//         </button>
        
//         {/* Page Left Category */}
//         <div className="absolute left-9 text-right text-xs font-bold text-gray-400"
//             onClick={() => setCurrentPage(prev => (prev - 1 + categories.length) % categories.length)}
//         >
//                   {/* Category Title */}
//           {categories[currentPage - 1]?.[0] || ''}
//         </div>

//           {/* CURRENT CATEGORY */}
//           <div className="text-[1.1em] font-bold text-gray-200">
//                     {/* Category Title */}
//             {categories[currentPage]?.[0] || ''}
//             {/* {currentPage + 1} / {categories.length} */}
//           </div>
        
//         {/* Page Right Category */}
//         <div className="absolute right-9 text-right text-xs font-bold text-gray-400"
//           onClick={() => setCurrentPage(prev => (prev + 1) % categories.length)}
//         >
//                   {/* Category Title */}
//           {categories[currentPage + 1]?.[0] || ''}
//         </div>
        
//         {/* Page Right */}
//         <button 
//           onClick={() => setCurrentPage(prev => (prev + 1) % categories.length)}
//           disabled={categories.length <= 1}
//           className="pr-2 py-1 disabled:opacity-30"
//         >
//           <ChevronRight size={20} />
//         </button>
//       </div>
//     </div>
//   );
// };

// export default SmartplayVideosList;